import { StyledAvatar, StyledMenu } from '@geosecma/sidebar';
import { Menu, Popover } from 'antd';
import { EditUserForm } from 'components/EditUser/EditUserForm';
import initials from 'initials';
import { observer } from 'mobx-react';
import { useRootStore } from 'models/rootModel';
import React from 'react';
import styled from 'styled-components';

const PopupContainer = styled.div`
  overflow-y: auto;
  height: 450px;
`;

const regex = new RegExp(/[&/\\#[\]|,+()$~%.'":*?<>{}!¤=]/g);

export const EditUserMenu = observer(({ logoutApi, ...props }) => {
  const [visible, setVisible] = React.useState(false);
  const rootStore = useRootStore();

  const { user } = rootStore;

  const onKeyDown = e => {
    if (e.key === 'Enter') {
      setVisible(!visible);
    } else if (e.key === 'Escape') {
      setVisible(false);
    }
  };

  return (
    <div>
      <Popover
        placement="rightTop"
        content={
          <PopupContainer>
            <EditUserForm logoutApi={logoutApi} visibleFnc={setVisible} {...props}></EditUserForm>
          </PopupContainer>
        }
        trigger="click"
        arrowPointAtCenter
        visible={visible}
        onVisibleChange={value => setVisible(value)}
        getPopupContainer={triggerNode => triggerNode.parentNode}
      >
        <StyledMenu theme="dark" selectable={false}>
          <Menu.Item tabIndex="0" onKeyDown={onKeyDown} {...props}>
            <span className="anticon">
              <StyledAvatar data-testid="usermenu-initials" style={{ backgroundColor: '#0277bd' }}>
                {initials(user.name.replace(regex, ''))}
              </StyledAvatar>
            </span>
            <span data-testid="userMenu-name">{user.name}</span>
          </Menu.Item>
        </StyledMenu>
      </Popover>
    </div>
  );
});
